import React from 'react'

import Confirmation from '@/atoms/Confirmation/Confirmation'
import { useTranslation } from '@/lib/i18n/i18n'

interface SncfConfirmationProps {
	close: () => void
	success: () => void
	isEnable: boolean
}

export const SncfConfirmation: React.FunctionComponent<SncfConfirmationProps> = (props) => {
	const { t } = useTranslation()

	// t('Enable SNCF content')
	// t('Disable SNCF content')
	return (
		<Confirmation
			title={t(`${props.isEnable ? 'Enable' : 'Disable'} SNCF content`)}
			prompt={t(
				'The SNCF content feature flag has been successfully updated. Please reload the page for the changes to take effect. Would you like to reload the page now?',
			)}
			okLabel={t('Confirm')}
			showCancelButton
			onOK={props.success}
			onCancel={props.close}
		/>
	)
}
